module.exports = __webpack_public_path__ + "static/media/lifting.a617a9bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Images/lifting.jpg
// module id = 52
// module chunks = 0